import {
    Component, Prop, Mixins, PropSync,
} from 'vue-property-decorator';
import CommonProps from '@components/shared/mixins/props';

/**
 * Button Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Button HTML Tag
     *
     * @values "button", "a", "router-link"
     */
    @Prop({ default: 'button' }) tag!: string;

    /**
     * The object of Vue Router
     * 
     * Tag should be `router-link`
     */
    @Prop() to!: Record<string, unknown>;

    /**
     * The href of the link
     * 
     * Tag should be `a`
     */
    @Prop() href!: string;

    /**
     * Fab button
     */
    @PropSync('fab', { type: String }) fabIcon!: string;

    /**
     * Loading State
     */
    @Prop({ type: Boolean }) loading!: boolean;

    /**
     * Loading State using _$wait_ service
     */
    @Prop() loadingOn!: string;

    /**
     * Disable State
     */
    @Prop({ type: Boolean }) disabled!: boolean;

    /**
     * Disable State using _$wait_ service
     */
    @Prop() disabledOn!: string;

    /**
     * Remove Padding of the right and left
     * Add padding of 8px to the right and left
     */
    @Prop({ type: Boolean, default: true }) noPadding!: boolean;

    /**
     * Prepend Icon Class
     */
    @Prop() iconPrepend!: string;

    /**
     * Append Icon Class
     */
    @Prop() iconAppend!: string;

    /**
     * Remove background and border of the button (Aka Button Link)
     */
    @Prop({ type: Boolean }) text!: boolean;

    /**
     * Remove background and border of the button and add opacity to the text in normal state
     */
    @Prop({ type: Boolean }) plain!: boolean;

    /**
     * Icons library code name. here's a list of supported icons libraries:
     * 'mdi' - Material Design Icons - https://materialdesignicons.com/
     * 'fa' - Font Awesome - https://fontawesome.com/icons
     */
    @Prop({ type: String, default: 'fa' }) library!: string;

    /**
     * Prefix of the icon
     * Font Awesome prefix: 'fab', 'far', 'fas'.
     */
    @Prop({ type: String, default: 'fas' }) prefix!: string

    /**
     * Icon size
     */
    @Prop({ type: String, default: 'small' }) iconSize!: string;
}

export default Props;
